/* eslint-disable css-modules/no-unused-class, camelcase  */

import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectUserUuid, selectLocale } from '@redux/slices/userSlice';
import { useGetAssignedContentData } from '@queries/platform/userContent';
import { Loader } from 'learning-panel-components';
import AssignedContentFullExpanded from './assignedContentFullExpanded';
import styles from './assignedContentFullExpanded.module.scss';

const AssignedContentFullExpandedContainer: FC<{ onClose: Function; onUnExpand: Function }> = ({
    onClose,
    onUnExpand
}: {
    onClose: Function;
    onUnExpand: Function;
}) => {
    const userUuid = useSelector(selectUserUuid);
    const userLocal = useSelector(selectLocale);
    const [primaryCourse, setPrimaryCourse] = useState<any>(null);
    const [assignedLessons, setAssignedLessons] = useState<any>(null);
    const [assignedAssessments, setAssignedAssessments] = useState<any>(null);
    const { data, isLoading } = useGetAssignedContentData(userUuid);

    useEffect(() => {
        if (!data?.data) return;
        const { primary_course, assigned_lessons, assessments } = data.data;
        const tempPrimaryCourse = {
            displayName: primary_course.course_display_name,
            uuid: primary_course.uuid,
            score: primary_course.score,
            assignedOn: primary_course.assigned_on,
            completionPercentage: primary_course.completion_percentage,
            iconUrl: primary_course.icon_url
        };
        setPrimaryCourse({ ...tempPrimaryCourse });

        const tempLessons: any[] = [];
        assigned_lessons?.lessons.map((lesson: any) =>
            tempLessons.push({
                uuid: lesson.uuid,
                displayName: lesson.display_name,
                url: lesson.url,
                score: lesson.score,
                assignedAt: lesson.assigned_at,
                status: lesson.status,
                iconUrl: lesson.icon_url
            })
        );

        const tempAssignedLessons = {
            total: assigned_lessons.total,
            completionPercentage: assigned_lessons.completion_percentage,
            lessons: tempLessons
        };

        setAssignedLessons({ ...tempAssignedLessons });

        const tempAssessments: any[] = [];
        assessments.assessments.map((assessment: any) =>
            tempAssessments.push({
                uuid: assessment.uuid,
                name: assessment.name,
                url: assessment.url,
                score: assessment.score,
                endDate: assessment.end_date,
                status: assessment.status
            })
        );

        const tempAssignedAssessments = {
            total: assessments.total,
            completionPercentage: assessments.completion_percentage,
            assessments: tempAssessments
        };

        setAssignedAssessments({ ...tempAssignedAssessments });
    }, [data]);

    return isLoading || primaryCourse === null ? (
        <Loader className={styles['assigned-content']} />
    ) : (
        <AssignedContentFullExpanded
            locale={userLocal}
            primaryCourse={primaryCourse}
            assignedLessons={assignedLessons}
            assignedAssessments={assignedAssessments}
            isLoading={false}
            onUnExpand={onUnExpand}
            onClose={onClose}
        />
    );
};

export default AssignedContentFullExpandedContainer;
